import IsValidSignUpData from "../ValidationChecker/signupValidation";
import { signup } from "../../api/authApi";
import AuthForm from "../common/authForm/AuthForm";
import { Link } from "react-router-dom";

const PersonalRegisterForm = () => {
    const handleSubmit = (values, callback) => {
        signup(values, callback);
    };

    const customFields = [
        {
            name: "first_name",
            type: "text",
            placeholder: "First Name",
            label: "First Name",
            required: true,
        },
        {
            name: "last_name",
            type: "text",
            placeholder: "Last Name",
            label: "Last Name",
            required: true,
        },
        {
            name: "email",
            type: "email",
            placeholder: "E-Mail",
            label: "Email",
            required: true,
        },
        {
            name: "phone_number",
            type: "tel",
            placeholder: "Phone Number",
            label: "Phone Number",
            id: 'phone_number_code',
            required: true,
        },
        {
            name: "company_name",
            type: "text",
            placeholder: "Company Name",
            label: "Company Name",
            required: false,
        },
        {
            name: "job_title",
            type: "text",
            placeholder: "Job Title",
            label: "Job Title",
            required: false,
        },
        {
            name: "sector_product_coverage",
            type: "text",
            placeholder: "Sector / Product Coverage",
            label: "Sector / Product Coverage",
            required: false,
        },
        {
            name: "country_region",
            type: "select",
            placeholder: "Country / Region",
            label: "Country / Region",
            options: [
                { value: "", label: "Select Country" },
                { value: "United States of America", label: "United States of America" },
                { value: "United Kingdom", label: "United Kingdom" },
                { value: "Canada", label: "Canada" },
            ],
            required: false,
        },
        {
            name: "how_did_you_hear",
            type: "select",
            label: "How Did You Hear About Us?",
            options: [
                { value: "", label: "How You Found Us" },
                { value: "Google", label: "Google" },
                { value: "Word of Mouth", label: "Word of Mouth" },
                { value: "Social Media", label: "Social Media" },
                { value: "Website", label: "Website" },
                { value: "Other", label: "Other" },
            ],
            required: true,
        },
        {
            name: "password",
            type: "password",
            placeholder: "Password",
            label: "Password",
            required: true,
        },
        {
            name: "confirm_password",
            type: "password",
            placeholder: "Confirm Password",
            label: "Confirm Password",
            required: true,
        },
        {
            name: "agree_to_terms",
            type: "checkbox",
            label: (
                <span>
                    I confirm that the information provided is accurate and I agree to the{" "}
                    <Link to="/terms-of-service" target="_blank">
                        Terms of Service
                    </Link>{" "}
                    and{" "}
                    <Link to="/privacy-policy" target="_blank">
                        Privacy & Policy
                    </Link>
                </span>
            ),
            required: true,
        },
    ];



    return (
        <AuthForm
            formType="New User Profile"
            initialValues={{
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
                company_name: "",
                job_title: "",
                sector_product_coverage: "",
                country_region: "",
                how_did_you_hear: "",
                password: "",
                confirm_password: "",
                agree_to_terms: false,
            }}
            validationFunc={IsValidSignUpData}
            onSubmit={handleSubmit}
            successRedirectPath="/otp-verification"
            buttonLabel="Create User"
            loadingLabel="Signing Up..."
            customLinks={[{ to: "/login", label: "Already have an account? Log-In" }]}
            customFields={customFields}
            subTitle = "Sign up to get started"
        />
    );
};

export default PersonalRegisterForm;
